export const NominalSubtypes = {
  PL_INCOME: "ProfitAndLoss_Income",
  PL_EXPENSE: "ProfitAndLoss_Income",
  PL_Other: "ProfitAndLoss_Other",
  OFFICE_BANK: "BalanceSheet_OfficeBank",
  CLIENT_BANK: "BalanceSheet_ClientBank",
  DDA_BANK: "BalanceSheet_DDABank",
  BS_OTHER: "BalanceSheet_Other",
};
